var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('top-bar'),_c('side-bar'),_c('v-main',{staticClass:"pt-14"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }